/**
 * File generated by js-routes 2.2.4
 * Based on Rails 6.1.7.3 routes of Troupe::Application
 */
const __jsr = (() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) || result === false ? "" : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters, } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_google_maps(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addByGoogleMapsTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_google_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_google_maps(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addByGoogleMapsTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_google_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_search(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addBySearchTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_search(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addBySearchTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_smart_search(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addBySmartSearchTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_smart_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_smart_search(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addBySmartSearchTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_smart_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_url(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addByURLTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/add_by_url(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addByURLTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"add_by_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiSearchURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_search"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ai_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aiSearchPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/search/ai_listings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiSearchAiListingsURL = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"ai_listings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/search/ai_listings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiSearchAiListingsPath = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"ai_listings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/search/listings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiSearchListingsURL = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"listings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/search/listings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiSearchListingsPath = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"listings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/trips/:trip_id/invites/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripInviteURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/trips/:trip_id/invites/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripInvitePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/trips/:trip_id/invites(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripInvitesURL = __jsr.r({"trip_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/trips/:trip_id/invites(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripInvitesPath = __jsr.r({"trip_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/trips/:trip_id/search/listings(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripSearchListingsURL = __jsr.r({"trip_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"listings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/trips/:trip_id/search/listings(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripSearchListingsPath = __jsr.r({"trip_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"listings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/trips/:trip_id/stays(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/trips/:trip_id/stays(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/trips/:trip_id/travelers/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripTravelerURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"travelers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/trips/:trip_id/travelers/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTripTravelerPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"travelers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/reauthenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authReauthenticateURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"reauthenticate"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /auth/reauthenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authReauthenticatePath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"reauthenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:id/close(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closeTripPollURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:id/close(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closeTripPollPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/invites/:id/decline(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineTripInviteURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/invites/:id/decline(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineTripInvitePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option/destroy_confirmation(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfirmationTripChosenDateOptionURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[2,[7,"/"],[2,[6,"destroy_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option/destroy_confirmation(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfirmationTripChosenDateOptionPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[2,[7,"/"],[2,[6,"destroy_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination/destroy_confirmation(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfirmationTripChosenDestinationURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[2,[7,"/"],[2,[6,"destroy_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination/destroy_confirmation(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfirmationTripChosenDestinationPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[2,[7,"/"],[2,[6,"destroy_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay/destroy_confirmation(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfirmationTripChosenStayURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[2,[7,"/"],[2,[6,"destroy_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay/destroy_confirmation(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyConfirmationTripChosenStayPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[2,[7,"/"],[2,[6,"destroy_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripURL = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripPath = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripActivityURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripActivityPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripActivityEventURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripActivityEventPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripActivityGroupURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripActivityGroupPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripDestinationURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripDestinationPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary/edit(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripItineraryURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary/edit(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripItineraryPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_dates/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripItineraryDateURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_dates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_dates/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripItineraryDatePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_dates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/notes/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripNoteURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/notes/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripNotePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripStayURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripStayPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripStayBookingURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripStayBookingPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripStayEventURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events/:id/edit(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTripStayEventPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /favorites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favoritesURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"favorites"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /favorites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favoritesPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"favorites"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/url_shortener/fetch_short_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetchShortLinkApiURLShortenerURL = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"url_shortener"],[2,[7,"/"],[2,[6,"fetch_short_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/url_shortener/fetch_short_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetchShortLinkApiURLShortenerPath = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"url_shortener"],[2,[7,"/"],[2,[6,"fetch_short_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /graphql(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphqlURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"graphql"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /graphql(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphqlPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"graphql"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trips/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /trips/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripActivityURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripActivityPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripActivityEventURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripActivityEventPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/batch_stays/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripBatchStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"batch_stays"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/batch_stays/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripBatchStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"batch_stays"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/broadcasts/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripBroadcastURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"broadcasts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/broadcasts/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripBroadcastPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"broadcasts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripChosenDateOptionURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripChosenDateOptionPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripChosenDestinationURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripChosenDestinationPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripChosenStayURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripChosenStayPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/date_options/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripDateOptionURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"date_options"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/date_options/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripDateOptionPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"date_options"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripDestinationURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripDestinationPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripItineraryURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripItineraryPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/notes/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripNoteURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/notes/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripNotePath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripPollURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripPollPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings/new(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripStayBookingURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings/new(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripStayBookingPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripStayEventURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripStayEventPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/voting/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripVotingURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"voting"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/voting/new(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTripVotingPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"voting"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/trips/:trip_id/invites/:id/resend(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendApiTripInviteURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/trips/:trip_id/invites/:id/resend(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendApiTripInvitePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/dates/set_suggesting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSuggestingPhaseTripDatesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[2,[7,"/"],[2,[6,"set_suggesting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/dates/set_suggesting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSuggestingPhaseTripDatesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[2,[7,"/"],[2,[6,"set_suggesting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/set_suggesting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSuggestingPhaseTripDestinationsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[6,"set_suggesting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/set_suggesting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSuggestingPhaseTripDestinationsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[6,"set_suggesting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/set_suggesting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSuggestingPhaseTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"set_suggesting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/set_suggesting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setSuggestingPhaseTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"set_suggesting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/dates/set_voting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVotingPhaseTripDatesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[2,[7,"/"],[2,[6,"set_voting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/dates/set_voting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVotingPhaseTripDatesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[2,[7,"/"],[2,[6,"set_voting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/set_voting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVotingPhaseTripDestinationsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[6,"set_voting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/set_voting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVotingPhaseTripDestinationsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[6,"set_voting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/set_voting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVotingPhaseTripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"set_voting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/set_voting_phase(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setVotingPhaseTripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[6,"set_voting_phase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripURL = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPath = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivitiesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivitiesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityEventURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityEventPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityEventsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_events(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityEventsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityGroupURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityGroupPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityGroupsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityGroupsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:activity_id/votes(.:format)
 * @param {any} tripId
 * @param {any} activityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityVotesURL = __jsr.r({"trip_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:activity_id/votes(.:format)
 * @param {any} tripId
 * @param {any} activityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripActivityVotesPath = __jsr.r({"trip_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/add_activities(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripAddActivitiesURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/add_activities(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripAddActivitiesPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/add_activities(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripAddActivitiesUpdateURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/add_activities(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripAddActivitiesUpdatePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/batch_stays(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripBatchStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"batch_stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/batch_stays(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripBatchStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"batch_stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/broadcasts/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripBroadcastURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"broadcasts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/broadcasts/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripBroadcastPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"broadcasts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/broadcasts(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripBroadcastsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"broadcasts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/broadcasts(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripBroadcastsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"broadcasts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDateOptionURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDateOptionPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option/note(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDateOptionNoteURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[2,[7,"/"],[2,[6,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_date_option/note(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDateOptionNotePath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_date_option"],[2,[7,"/"],[2,[6,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDestinationURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDestinationPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination/note(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDestinationNoteURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[2,[7,"/"],[2,[6,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_destination/note(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenDestinationNotePath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_destination"],[2,[7,"/"],[2,[6,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenStayURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenStayPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay/note(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenStayNoteURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[2,[7,"/"],[2,[6,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/chosen_stay/note(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripChosenStayNotePath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"chosen_stay"],[2,[7,"/"],[2,[6,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/dates/:date_option_id(.:format)
 * @param {any} tripId
 * @param {any} dateOptionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDateURL = __jsr.r({"trip_id":{"r":true},"date_option_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[2,[7,"/"],[2,[3,"date_option_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/dates/:date_option_id(.:format)
 * @param {any} tripId
 * @param {any} dateOptionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDatePath = __jsr.r({"trip_id":{"r":true},"date_option_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[2,[7,"/"],[2,[3,"date_option_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/date_options(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDateOptionsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"date_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/date_options(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDateOptionsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"date_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/dates(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDatesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/dates(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDatesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDeleteActivityURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDeleteActivityPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:destination_id/comments/:id(.:format)
 * @param {any} tripId
 * @param {any} destinationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationCommentURL = __jsr.r({"trip_id":{"r":true},"destination_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"destination_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:destination_id/comments/:id(.:format)
 * @param {any} tripId
 * @param {any} destinationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationCommentPath = __jsr.r({"trip_id":{"r":true},"destination_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"destination_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:destination_id/comments(.:format)
 * @param {any} tripId
 * @param {any} destinationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationCommentsURL = __jsr.r({"trip_id":{"r":true},"destination_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"destination_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:destination_id/comments(.:format)
 * @param {any} tripId
 * @param {any} destinationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationCommentsPath = __jsr.r({"trip_id":{"r":true},"destination_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"destination_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:destination_id/rankings(.:format)
 * @param {any} tripId
 * @param {any} destinationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationRankingsURL = __jsr.r({"trip_id":{"r":true},"destination_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"destination_id"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations/:destination_id/rankings(.:format)
 * @param {any} tripId
 * @param {any} destinationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationRankingsPath = __jsr.r({"trip_id":{"r":true},"destination_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[2,[7,"/"],[2,[3,"destination_id"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/destinations(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripDestinationsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"destinations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:activity_id(.:format)
 * @param {any} tripId
 * @param {any} activityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripGetActivityURL = __jsr.r({"trip_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:activity_id(.:format)
 * @param {any} tripId
 * @param {any} activityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripGetActivityPath = __jsr.r({"trip_id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/invites(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripInvitesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/invites(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripInvitesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_dates/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryDateURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_dates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_dates/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryDatePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_dates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_dates(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryDatesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_dates(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryDatesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_events/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryEventURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/itinerary_events/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripItineraryEventPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"itinerary_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/notes/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripNoteURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/notes/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripNotePath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/notes(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripNotesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/notes(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripNotesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:poll_id/comments(.:format)
 * @param {any} tripId
 * @param {any} pollId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollCommentsURL = __jsr.r({"trip_id":{"r":true},"poll_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"poll_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:poll_id/comments(.:format)
 * @param {any} tripId
 * @param {any} pollId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollCommentsPath = __jsr.r({"trip_id":{"r":true},"poll_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"poll_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:poll_id/responses(.:format)
 * @param {any} tripId
 * @param {any} pollId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollResponsesURL = __jsr.r({"trip_id":{"r":true},"poll_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"poll_id"],[2,[7,"/"],[2,[6,"responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/polls/:poll_id/responses(.:format)
 * @param {any} tripId
 * @param {any} pollId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollResponsesPath = __jsr.r({"trip_id":{"r":true},"poll_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[2,[7,"/"],[2,[3,"poll_id"],[2,[7,"/"],[2,[6,"responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/polls(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/polls(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripPollsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"polls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/remove_activity/:activity_id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {any} activityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripRemoveActivityURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_activity"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activity_groups/:id/remove_activity/:activity_id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {any} activityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripRemoveActivityPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"activity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activity_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_activity"],[2,[7,"/"],[2,[3,"activity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings/:id(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayBookingURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings/:id(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayBookingPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayBookingsURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/bookings(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayBookingsPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/comments/:id(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayCommentURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/comments/:id(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayCommentPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/comments(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayCommentsURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/comments(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayCommentsPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayEventURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayEventPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayEventsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stay_events(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayEventsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stay_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/rankings(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayRankingsURL = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays/:stay_id/rankings(.:format)
 * @param {any} tripId
 * @param {any} stayId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStayRankingsPath = __jsr.r({"trip_id":{"r":true},"stay_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[2,[7,"/"],[2,[3,"stay_id"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/stays(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStaysURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/stays(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripStaysPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"stays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/travelers/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripTravelerURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"travelers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/travelers/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripTravelerPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"travelers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/travelers(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripTravelersURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"travelers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/travelers(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripTravelersPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"travelers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUpdateActivityURL = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/activities/:id(.:format)
 * @param {any} tripId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUpdateActivityPath = __jsr.r({"trip_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/updates(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUpdatesURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/updates(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUpdatesPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/updates_view_logs(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUpdatesViewLogsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"updates_view_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/updates_view_logs(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUpdatesViewLogsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"updates_view_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/user_broadcast_view_logs(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUserBroadcastViewLogsURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"user_broadcast_view_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/user_broadcast_view_logs(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripUserBroadcastViewLogsPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"user_broadcast_view_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips/:trip_id/voting(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripVotingURL = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"voting"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /trips/:trip_id/voting(.:format)
 * @param {any} tripId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripVotingPath = __jsr.r({"trip_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trips"],[2,[7,"/"],[2,[3,"trip_id"],[2,[7,"/"],[2,[6,"voting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripsURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trips"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /trips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tripsPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trips"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersURL = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPath = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

